import { CommonsEnvironment } from '@infodata-group/inf-commons';

export const environment: CommonsEnvironment = {
  production: true,
  env: 'preprod',

  api: {
    apiEndPoint: 'api/',
    settingsApi: 'auth/settings',
  },
  app: {
    defaultRoute: 'main',
    appName: 'Comptabilité',
    appVersion: '0.4.1',
    appVersionDate: '23/03/2022',
    appId: '5080z9xq-9892-89pl-2t87-95z4g69ed45c',
    lang: ['fr'],
  },
  auth: {
    loginUrl: 'api/auth-default',
    initApi: null,
  },
  login: {
    loginRoute: 'login',
    defaultConnection: true,
  },
  ui: {
    appLogoPath: 'https://assets.integrix.lu/img/logos/integrix-compta.svg',
    companyLogoPath: 'https://assets.integrix.lu/img/logos/infodata.svg',
    lockerBackgroundPath:
      'https://assets.integrix.lu/img/backgrounds/2025.webp',
  },
};
